import React from 'react';
import * as PropTypes from 'prop-types';
import { get } from 'lodash';
import { ReactTableDefaults } from 'react-table';
import Button from 'components/Button';

export default function LimitedFooterComponent({
  children,
  showMore,
  rowCount,
  currentLimit,
  isFirstColumnFtTaken,
}) {
  const tdComponents = get(children, 'props.children');
  const style = tdComponents[0].props.style;
  const isShowMore = currentLimit < rowCount;
  if (rowCount > 1 && tdComponents[0].props.children) {
    return (
      <>
        <div className={'rt-tr'}>{tdComponents}</div>
        {isShowMore && isFirstColumnFtTaken && (
          <div className={'rt-tr'}>
            <ReactTableDefaults.TdComponent onClick={showMore} style={style}>
              {isShowMore && (
                <Button onClick={showMore} type={'button'} isLinkStyled={true} hasWrapper={false}>
                  Показать ещё
                </Button>
              )}
            </ReactTableDefaults.TdComponent>
          </div>
        )}
      </>
    );
  }
  return null;
}

LimitedFooterComponent.propTypes = {
  children: PropTypes.node,
  showMore: PropTypes.func,
  rowCount: PropTypes.number,
  currentLimit: PropTypes.number,
  isFirstColumnFtTaken: PropTypes.bool,
};
